<!--仓库名称下拉框（商户端）-->
<template>
  <!-- <div> -->
  <el-select v-model="value"
             placeholder="请选择">
    <el-option v-for="(item, index) in list"
              :key="item.value"
              :label="item.name"
              :value="item.value"
              @click.native="handelChange(item.value,index)">
    </el-option>
  </el-select>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    warehouseCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      list: [],
      warehouseCodes: localStorage.getItem('warehouseCodes'),
      value: '',
      activeIndex: 0
    }
  },
  mounted () {
    this.setValue()
  },
  computed: {
    // 判断新增编辑删除等操作是否有权限
    hasAuthority () {
      return this.getValue().isLmOpen === 1
    }
  },
  methods: {
    setValue () {
      this.list = JSON.parse(this.warehouseCodes) || []
      if (!this.list.length) return false
      this.value = this.list[0].value
      this.handelChange(this.value, 0)
    },
    getValue () {
      return this.list[this.activeIndex]
    },
    // 判断该仓库是否开启生产日期开关
    isMdOpen (value) {
      if (value) {
        let result = this.list.find(item => item.value === value)
        return result.isMdOpen === 1
      }
      if (this.getValue()) {
        return this.getValue().isMdOpen === 1
      }
      return false
    },
    // 判断该仓库是否开启生产日期开关或货位开关
    isLmOpenOrIsMdOpen (value) {
      if (value) {
        let result = this.list.find(item => item.value === value)
        return result.isMdOpen === 1 || result.isLmOpen === 1
      }
      if (this.getValue()) {
        return this.getValue().isMdOpen === 1 || this.getValue().isLmOpen === 1
      }
      return false
    },
    handelChange (warehouseCode, index) {
      this.activeIndex = index
      this.$emit('change', this.hasAuthority)
      this.$emit('update:warehouseCode', warehouseCode)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/WarehouseSelect.vue